import { NextPageContext } from 'next'
import { domainComparison } from '@ucheba/utils/middlewares/domainComparison'
import { isBrowser } from '@ucheba/utils/helpers/core'
import { parseUrl } from '@ucheba/utils/helpers/router'

export const getCanonicalByDomain = (
  ctx: NextPageContext,
  domain?: string
): string | void => {
  const { req } = ctx
  const host = isBrowser ? window.location.host : req?.headers.host
  const url = isBrowser ? `${window.location.pathname}` : parseUrl(req?.url || '').url

  const isLocal = host?.includes('localhost')

  if ((isBrowser || req) && domain && !domainComparison(ctx, domain) && !isLocal) {
    const hostSep = host?.split('.')

    if (hostSep) {
      hostSep[0] = domain

      const newHost = hostSep.join('.')

      return `https://${newHost}${url}`
    }
  }

  return undefined
}
